import { render, staticRenderFns } from "./SchedaPaziente.vue?vue&type=template&id=3ebfa708&scoped=true&"
import script from "./SchedaPaziente.vue?vue&type=script&lang=js&"
export * from "./SchedaPaziente.vue?vue&type=script&lang=js&"
import style0 from "./SchedaPaziente.vue?vue&type=style&index=0&id=3ebfa708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebfa708",
  null
  
)

export default component.exports